// extracted by mini-css-extract-plugin
export default {"card":"styles_card__tMbr5","message":"styles_message__hbkws"};